export const DEPARTMENTS = [

  {
    id: 1,
    value: "Dentist",
  },
  {
    id: 2,
    value: "Cardiologist",
  },
];

export const GENDER = [
  {
    id: 1,
    value: "M",
    text: "Male"
  },
  {
    id: 2,
    value: "F",
    text: "Female"
  },
  {
    id: 3,
    value: "U",
    text: "Unknown"
  },
];
